import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, Stack, TextField, Typography } from "@mui/material"
import { PrincipalLayouts } from "../../../layouts"
import { useForm } from "../../../hooks";
import { DateInput } from "../DateInput";
import { Field } from "../miProfile/Field";
import { toEnglishDate } from "../../../helpers/dateFormat";
import { createRound } from "../../helpers/opportunity";
import { createDividend } from "../../helpers/dividend";

export const CreateRound = ({ startupList, vehiclesList }) => {

    const { t } = useTranslation('global');
    const navigate = useNavigate();
    const startupsNames = startupList.map(startup => startup.name)
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);

    const [isWaiting, setIsWaiting] = useState(false);
    const [formValues, handleInputChange, reset] = useForm({ dateOpportunityInvestment: '', reservationDeadline: '', investmentType: 'Ampliación Capital', roundNumber: '', urlVideo: '', startup: startupsNames[0], status: 'Activo', vehicle: vehiclesList[0], totalAmount: '' });

    const { dateOpportunityInvestment, investmentType,  urlVideo, startup, vehicle, totalAmount } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        const startupSelected = startupList.find(p => p.name === startup)
        if (investmentType === 'Reparto de dividendos') {
            await createDividend({
                startupId: startupSelected.id,
                vehicle,
                dividendDate: dateOpportunityInvestment,
                totalAmount: parseFloat(totalAmount)
            }, t('opportunities.successMsgDividend'), t('opportunities.errorMsg'), navigate)
        } else {
            await createRound({ ...formValues, startupId: startupSelected.id, haveConfirmedInvestment: true, reservationDeadline: toEnglishDate(actualDate), dateOpportunity: dateOpportunityInvestment }, t('opportunities.successMsgRound'), t('opportunities.errorMsg'), navigate)
        }

        setIsWaiting(false)
        reset()
    }
    const handleCancel = () => {
        reset();
        navigate('/positions')
    }

    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('opportunities.addRound')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack width='100%' gap={2}>
                    <Stack direction='column' width='100%' gap={0}>
                        <Typography variant='overline' color='secondary'>{t('opportunities.startup')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={startupsNames}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='startup' />}
                            value={startup}
                            onChange={(event, newValue) => {
                                handleInputChange({
                                    target: {
                                        name: 'startup',
                                        value: newValue || ""
                                    }
                                });
                            }}
                            fullWidth
                            required
                        />
                    </Stack>
                    <Stack direction='column' width='100%' gap={0}>
                        <Typography variant='overline' color='secondary'>{t('opportunities.investmentType')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={['Ampliación Capital', 'Préstamo Convertible', 'Reparto de dividendos']}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='investmentType' />}
                            value={investmentType}
                            onChange={(event, newValue) => {
                                handleInputChange({
                                    target: {
                                        name: 'investmentType',
                                        value: newValue || ""
                                    }
                                });
                            }}
                            fullWidth
                            required
                        />
                    </Stack>

                    <Stack>
                        <DateInput name={dateOpportunityInvestment} title='dateOpportunityInvestment' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    {investmentType !== 'Reparto de dividendos' && (
                        <Stack width='100%'>
                            <Field translation='opportunities' name={urlVideo} title='urlVideo' handleInputChange={handleInputChange} />
                        </Stack>
                    )}

                    {investmentType === 'Reparto de dividendos' && (
                        <Stack direction='column' width='100%' gap={0}>
                            <Typography variant='overline' color='secondary'>{t('opportunities.dividendPerShare')}</Typography>
                            <TextField
                                fullWidth
                                name='totalAmount'
                                size="small"
                                variant="outlined"
                                value={totalAmount}
                                onChange={handleInputChange}
                                required={true}
                                type='number'
                                InputProps={{ inputProps: { min: 0.01, step: 'any' } }}
                            />
                        </Stack>
                    )}

                    <Stack direction='column' width='100%' gap={0}>
                        <Typography variant='overline' color='secondary'>{t('opportunities.vehicle')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={vehiclesList}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='vehicle' />}
                            value={vehicle}
                            onChange={(event, newValue) => {
                                handleInputChange({
                                    target: {
                                        name: 'vehicle',
                                        value: newValue || ""
                                    }
                                });
                            }}
                            fullWidth
                            required
                        />
                    </Stack>

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting || vehicle === ''} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}